import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useEmployee from "../../../hooks/useEmployee";
import useEmailMaster from "../../../hooks/useEmailMaster";
import useBranch from "../../../hooks/useBranch";

import SearchableAutoComplete from "../../../components/SearchableAutoComplete";
import FilterReset from "../../../components/FilterReset";
import { searchPayload, convertedValue } from "../../../utils/common";
import { OperatorConstants } from "../../../constants/operator.constants";
import ReactHookFormSelect from "../../../components/ReactHookFormSelect";
import CustomTextField from "../../../components/CustomTextField";
import { useDialog } from "../../../contexts/DialogContext";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const statusOptions = [
  {
    label: "Active",
    value: "A",
  },
  {
    label: "InActive",
    value: "INA",
  },
];
const leadTypeOptions = [
  {
    label: "General Inquiry",
    value: "GENERAL INQUIRY",
  },
  {
    label: "New Connection",
    value: "NEW CONNECTION",
  },
];

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const initialValues = {
    customerNameOperator: "eq",
    leadTypeOperator: "eq",
    statusOperator: "eq",
    customerName: "",
    leadType: "",
    status: [],
  };

  const { fields, payload, setPayload, setFilterResetFunc } = props;

  const [statusMultiValue, setStatusMultiValue] = useState(false);

  const [defaultStatus, setDefaultStatus] = useState([]);

  const [leadTypeMultiValue, setLeadTypeMultiValue] = useState(false);

  const [defaultLeadType, setDefaultLeadType] = useState([]);

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => reset);
  }, [reset]);

  const customerNameOpValue = watch("customerNameOperator");

  const statusOpValue = watch("statusOperator");
  const leadTypeOpValue = watch("leadTypeOperator");

  const onSubmit = async (data) => {
    try {
      let filters = [];

      if (data.customerName != null && Object.keys(data.customerName).length != 0) {
        filters.push({
          fieldName: "customerName",
          fieldValue: data.customerName,
          op: data.customerNameOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.leadType != "" && data.leadType != null && Object.keys(data.leadType).length != 0) {
        filters.push({
          fieldName: "leadType",
          fieldValue: convertedValue(data.leadType, "value").join(","),
          op: data.leadTypeOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.status != null && Object.keys(data.status).length != 0) {
        filters.push({
          fieldName: "status",
          fieldValue: convertedValue(data.status, "value").join(","),
          op: data.statusOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.log(err, "errerrerrerr");
    }
  };

  useEffect(() => {
    if (leadTypeOpValue == "in" || leadTypeOpValue == "nin") {
      setDefaultLeadType([]);
      setValue("leadType", []);
      setLeadTypeMultiValue(true);
    } else {
      setDefaultLeadType({});
      setValue("leadType", {});
      setLeadTypeMultiValue(false);
    }
  }, [leadTypeOpValue]);

  useEffect(() => {
    if (statusOpValue == "in" || statusOpValue == "nin") {
      setDefaultStatus([]);
      setValue("status", []);
      setStatusMultiValue(true);
    } else {
      setDefaultStatus({});
      setValue("status", {});
      setStatusMultiValue(false);
    }
  }, [statusOpValue]);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} pt={8}>
            <Grid item xs={9.5} sm={6} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="customerNameOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.string).map((value, k) => (
                  <MenuItem key={k} value={value[0]}>
                    {value[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item md={6}>
              <CustomTextField
                label={t("customer_name")}
                name="customerName"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
            <Grid item xs={9.5} sm={6} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="leadTypeOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.dropdown).map((value, k) => (
                  <MenuItem key={k} value={value[0]}>
                    {value[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={6} md={6} lg={6} xl={4}>
              <SearchableAutoComplete
                control={control}
                data={leadTypeOptions}
                label="LeadType"
                payload={null}
                setPayload={null}
                loading={false}
                name="leadType"
                multiple={leadTypeMultiValue}
                defaultValue={defaultLeadType}
              />
            </Grid>
          </Grid>
          <Grid container spacing={12} pt={8}>
            <Grid item xs={9.5} sm={6} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="statusOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.dropdown).map((t, k) => (
                  <MenuItem key={k} value={t[0]}>
                    {t[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={6} md={6} lg={6} xl={4}>
              <SearchableAutoComplete
                control={control}
                data={statusOptions}
                label="Status"
                payload={null}
                setPayload={null}
                loading={false}
                name="status"
                multiple={statusMultiValue}
                defaultValue={defaultStatus}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={reset} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
